export const AP = 'ap';
export const CL = 'cl';
export const CR = 'cr';
export const DV = 'dv';
export const IM = 'im';
export const KW = 'kw';
export const LOC = 'loc';
export const MA = 'ma';
export const MF = 'mf';
export const MS = 'ms';
export const MT = 'mt';
export const NW = 'nw';
export const PL = 'pl';
export const PN = 'pn';
export const TS = 'ts';
export const DLP = 'dlp';
export const TMS = 'tms';
export const UTM_EXPID = 'utm_expid';
